(() => {
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!supportsHover.matches) return;

  const loadSecondary = (card) => {
    const image = card.querySelector('[data-fg-secondary-image]');
    if (!image || image.dataset.loaded === 'true') return;
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    if (image.dataset.src) image.src = image.dataset.src;
    image.dataset.loaded = 'true';
  };

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest('.product-card-wrapper');
    if (card) loadSecondary(card);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const card = event.target.closest('.product-card-wrapper');
    if (card) loadSecondary(card);
  });
})();
